import request from '@/utils/request'

// 查询列表
export function apiInvWipAllocationPlanCompartmentList (query) {
  return request({
    url: '/inv/invWipAllocationPlan/compartmentList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiInvWipAllocationPlanDispatchUpdate (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchUpdate',
    method: 'post',
    data: data
  })
}

// 发布
export function apiInvWipAllocationPlanDispatchRelease (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchRelease',
    method: 'post',
    data: data
  })
}

// 执行运算-基地仓
export function apiInvWipAllocationPlanDispatchOperations (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchOperations',
    method: 'post',
    data: data
  })
}

// 调度执行运算-卫星仓
export function apiInvWipAllocationPlanDdispatchOperationsForWxc (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchOperationsForWxc',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiInvWipAllocationPlanNewExport (data) {
  return request({
    url: 'inv/invWipAllocationPlan/v2/dispatchExport',
    method: 'post',
    data: data
  })
}

// 作废
export function apiInvWipAllocationPlanDispatchCancel (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchCancel',
    method: 'post',
    data: data
  })
}

// 新增列表
export function apiInvWipAllocationPlanDispatchAddList (query) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchAddList',
    method: 'get',
    params: query
  })
}

// 批量导入后根据批次号刷新调拨列表
export function apiInvWipAllocationPlanQueryByBatch (query) {
  return request({
    url: '/inv/invWipAllocationPlan/queryByBatch',
    method: 'get',
    params: query
  })
}

// 新增
export function apiInvWipAllocationPlanDispatchAddUpdate (data) {
  return request({
    url: '/inv/invWipAllocationPlan/dispatchAddUpdate',
    method: 'post',
    data: data
  })
}
